<template>
  <div class>
    <button class="btn_default" @click.prevent="show">
      Ny
    </button>
    <modal name="modal-create" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">NYTT API SCOPE</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()" class="space-y-4">

            <div>
              <ValidationProvider v-slot="{ errors }" name="Namn" rules="required">
                <span class="text-gray-700">Namn</span>
                <input v-model="scope.name" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Visningsnamn" rules="required">
                <span class="text-gray-700">Visningsnamn</span>
                <input v-model="scope.displayName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Beskrivning" rules="max:250">
                <span class="text-gray-700">Beskrivning</span>
                <textarea rows="4" v-model="scope.description" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      scope: {
        name: "",
        displayName: "",
        description: "",
        emphasize: false,
        showInDiscoveryDocument: true
      }
    };
  },

  methods: {
    ...mapActions("apiresourcesStore", ["addScope"]),
    show() {
      this.$modal.show("modal-create");
    },
    opened() {
      // this.cart.description = "";
      // this.$refs.description.focus();
    },
    async onCreate() {
      await this.addScope(this.scope);
      this.$modal.hide("modal-create");
    }
  }
};
</script>
